var map = {
	"./,0155035,0155036.webp": "./public/imagenesPromociones/,0155035,0155036.webp",
	"./,06501009,06501010, 06501011,06501012,06501013,.webp": "./public/imagenesPromociones/,06501009,06501010, 06501011,06501012,06501013,.webp",
	"./,06506368,06506369,06500010, 06500011,06500012,06500014,.webp": "./public/imagenesPromociones/,06506368,06506369,06500010, 06500011,06500012,06500014,.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/imagenesPromociones sync \\.(png%7Cwebp)$";